import React, { FC } from 'react';

import { Container, CrossIcon } from './styles';

export const TagItem: FC<{
  value: string;
  disabled?: boolean;
  onClick: (value: string) => void;
}> = ({ value, disabled, onClick }) => {
  return (
    <Container data-testid={`tag-item-${value}`} disabled={disabled} onClick={() => onClick(value)}>
      <span>{value}</span>
      <CrossIcon size={16} />
    </Container>
  );
};
